(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Category-custom"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const slider = document.getElementById("sliderTrack");
  const dotsContainer = document.getElementById("dotsContainer");
  const cards = slider.querySelectorAll(".category-card");

  let currentIndex = 0;

  function getCardsPerView() {
    if (window.innerWidth <= 480) return 1;
    if (window.innerWidth <= 768) return 2;
    if (window.innerWidth <= 1024) return 3;
    return 4;
  }

  function getScrollAmount() {
    const card = slider.querySelector(".category-card");
    const cardGap = 20;
    return card.offsetWidth + cardGap;
  }

  function getMaxIndex() {
    return Math.max(0, Math.ceil(cards.length / getCardsPerView()) - 1);
  }

  function updateDots(index) {
    const total = Math.ceil(cards.length / getCardsPerView());
    dotsContainer.innerHTML = "";

    for (let i = 0; i < total; i++) {
      const dot = document.createElement("span");
      dot.className = "dot page-indicator slider-dot";
      if (i === index) {
        dot.classList.add("active");
      }
      dot.addEventListener("click", function () {
        currentIndex = i;
        slider.scrollTo({
          left: i * getScrollAmount(),
          behavior: "smooth"
        });
        updateDots(currentIndex);
      });
      dotsContainer.appendChild(dot);
    }
  }

  function scrollSlider(direction) {
    const max = getMaxIndex();
    currentIndex += direction;

    if (currentIndex > max) {
      currentIndex = 0; // loop to start
    } else if (currentIndex < 0) {
      currentIndex = max; // loop to end
    }

    slider.scrollTo({
      left: currentIndex * getScrollAmount(),
      behavior: "smooth"
    });
    updateDots(currentIndex);
  }

  window.scrollSlider = scrollSlider;

  function syncDotWithScroll() {
    const scrollLeft = slider.scrollLeft;
    const index = Math.round(scrollLeft / getScrollAmount());
    if (index !== currentIndex) {
      currentIndex = index;
      updateDots(index);
    }
  }

  slider.addEventListener("scroll", () => {
    syncDotWithScroll();
  });

  window.addEventListener("resize", () => {
    updateDots(currentIndex);
  });

  updateDots(currentIndex);

  // ✅ Autoplay every 3 seconds
  setInterval(() => {
    scrollSlider(1);
  }, 3000);
});

  } catch(e) { console.error(e); }
})();
})();
